import userSupport from './reducers';

export {default as userSupportActions} from './actions';
export {default as userSupportTypes}   from './types';

export default userSupport;